// Admin Side Menu List
const adMenuList = [
  {
    id: '1',
    title: '대시보드',
    children: [
      {
        ico: 'icofont-dashboard-web',
        title: 'Dashboard',
        url: '/admin/dashboard',
      }
    ]
  },
  {
    id: '2',
    title: '리스트 관리',
    roles: 2,
    children: [
      {
        ico: 'icofont-data',
        title: 'KM',
        url: '/admin/km',
        children: [
          {
            title: 'KM 메뉴 리스트',
            url: '/admin/km/list',
          },
          {
            title: 'KM 메뉴 관리',
            url: '/admin/km/add',
            url2: '/admin/km/view',
          },
          {
            title: 'KM 카테고리 관리',
            url: '/admin/km/space-list',
            url2: '/admin/km/space-view',
          },
        ]
      },
      {
        ico: 'icofont-search-document',
        title: 'Dev Guide',
        url: '/admin/dev-guide',
        children: [
          {
            title: 'Security Policy',
            url: '/admin/dev-guide/policy/list',
            url2: '/admin/dev-guide/policy/view',
          },
          {
            title: 'Development Regulation',
            url: '/admin/dev-guide/regulation/list',
            url2: '/admin/dev-guide/regulation/view',
          },
        ]
      },
      {
        ico: 'icofont-support',
        title: 'Dev Support',
        url: '/admin/dev-support',
        children: [
          {
            title: '문의 내역 관리',
            url: '/admin/dev-support/list',
            url2: '/admin/dev-support/replay-mail',
          },
          {
            title: '서비스 관리',
            url: '/admin/dev-support/service-list',
            url2: '/admin/dev-support/service-view',
          },
        ]
      },
      {
        ico: 'icofont-support-faq',
        title: 'FAQ',
        url: '/admin/faq',
      },
      {
        ico: 'icofont-newspaper',
        title: 'News',
        url: '/admin/news',
      },
      {
        ico: 'icofont-users-social',
        title: 'Conference',
        url: '/admin/conference',
      },
      {
        ico: 'icofont-search-job',
        title: '개발자 채용',
        roles: 5,
        url: '/admin/dev-employ',
        children: [
          {
            title: '채용 글 관리',
            url: '/admin/dev-employ/incruit/list',
            url2: '/admin/dev-employ/incruit/view',
          },
          {
            title: '지원자 관리',
            url: '/admin/dev-employ/join/list',
            url2: '/admin/dev-employ/join/view',
          },
        ]
      },
    ]
  },
  {
    id: '3',
    title: '계정 관리',
    roles: 2,
    children: [
      {
        ico: 'icofont-address-book',
        title: '관리자 회원 관리',
        url: '/admin/member-mgt',
        roles: 5,
      },
      {
        ico: 'icofont-id',
        title: '고객 관리',
        url: '/admin/customer-mgt',
      },
    ]
  },
  {
    id: '4',
    title: '검토/승인',
    children: [
      {
        ico: 'icofont-fountain-pen',
        title: '검토/승인 관리',
        url: '/admin/review-aprv/mgt'
      },
      {
        ico: 'icofont-history',
        title: '검토/승인 요청 조회',
        url: '/admin/review-aprv/receipt'
      },
      {
        ico: 'icofont-hand-drag1',
        title: '검토/승인자 지정',
        url: '/admin/review-aprv/appt'
      },
      {
        ico: 'icofont-people',
        title: '검토/승인자 목록 관리',
        url: '/admin/review-aprv/list',
        roles: 5,
      },
    ]
  }
]

module.exports = { adMenuList }